import React from 'react';
import VerifiedIcon from '../../../icons/VerifiedIcon';
var widgetHeadings = {
    racetrac: 'Apply for FDD-compliant Insurance',
    hartford: "Apply for Workers' Comp Insurance",
    hartford_paf: 'Get a Free Insurance Policy Audit',
    briza_unified_hiscox: 'Quote and Buy Insurance'
};
var StartRequest = function (_a) {
    var theme = _a.theme, style = _a.style, buttonLabel = _a.buttonLabel, isButtonDisabled = _a.isButtonDisabled, disabledTooltip = _a.disabledTooltip, handleClick = _a.handleClick, _b = _a.isBroker, isBroker = _b === void 0 ? false : _b, _c = _a.widgetFlow, widgetFlow = _c === void 0 ? '' : _c;
    var heading = isBroker
        ? 'Start a Quote for Your Horses'
        : widgetHeadings[widgetFlow] || 'Buy your policy now';
    var buttonEffectClass = isButtonDisabled
        ? ''
        : theme == 'night'
            ? 'rippleNight'
            : 'ripple';
    var buttonStateClass = isButtonDisabled
        ? 'cursor-not-allowed opacity-70 text-black'
        : 'bg-primary text-primary';
    return (React.createElement("div", { className: "rounded-3xl mx-2 mt-30 px-12 bg-backgroundColor my-2 flex flex-col h-full justify-center text-textColor" },
        React.createElement("div", { className: "flex flex-col items-center justify-center" },
            React.createElement(VerifiedIcon, null),
            React.createElement("span", { className: "text-2xl font-bold text-center w-full mt-5 text-[#1F2751]" }, heading),
            widgetFlow === 'hartford_paf' && (React.createElement("span", { className: "text-base font-normal text-center mt-1 text-[#6B7280]" }, "Identify coverage you don\u2019t need and what you\u2019re missing"))),
        React.createElement("div", { className: "mt-6 w-full", title: isButtonDisabled ? disabledTooltip : undefined },
            React.createElement("button", { className: "rounded-2xl ".concat(buttonEffectClass, " ").concat(buttonStateClass, " font-bold mx-auto tracking-lighter px-8 py-4 w-full"), style: style, onClick: handleClick, disabled: isButtonDisabled }, buttonLabel))));
};
export default StartRequest;
